<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>项目支付</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="form-box pay__pro">
            <div class="pay--header">
                <div class="title">
                    <div class="status-bar">
                        项目提交成功，请尽快付款！项目编号：{{info.no}}
                    </div>
                    <div class="price">
                        <span class="label">实付金额:</span>
                        <span class="value">{{parseAmount(info.total)}}</span>
                    </div>
                </div>
                <div class="desc">
                    <div class="tips">
                        请在24小时内完成支付，超时订单会自动取消
                    </div>
                    <div class="pop-handle">
                        <el-popover
                            placement="bottom-end"
                            width="1000"
                            trigger="click">
                            <div>
                                <div class="pro-info-box">
                                    <div class="box">
                                        <div class="box__label">项目名称:</div>
                                        <div class="box__item">
                                            {{info.name}}
                                        </div>
                                    </div>
                                    <div class="box">
                                        <div class="box__label">预计完成时间:</div>
                                        <div class="box__item">
                                            {{info.complete_time}}
                                        </div>
                                    </div>
                                </div>
                                <div class="table striped--header">
                                    <el-table
                                        :data="info.service"
                                    >
                                        <el-table-column
                                            prop="name"
                                            align="center"
                                            width="200"
                                            :show-overflow-tooltip="true"
                                            label="服务名称">
                                        </el-table-column>
                                        <el-table-column
                                            prop="unit"
                                            align="center"
                                            label="单位">
                                        </el-table-column>
                                        <el-table-column
                                            prop="demand"
                                            align="center"
                                            :show-overflow-tooltip="true"
                                            label="业务规则">
                                        </el-table-column>
                                        <el-table-column
                                            prop="amount"
                                            align="center"
                                            label="预估人数">
                                        </el-table-column>
                                        <el-table-column
                                            label="预估单价"
                                            align="center"
                                            prop="price">
                                        </el-table-column>
                                        <el-table-column
                                            label="预估总价"
                                            align="center"
                                            width="140"
                                            prop="money">
                                        </el-table-column>
                                    </el-table>
                                    <div class="table__like">
                                        <div class="td">平台综合服务费</div>
                                        <div class="td-flex"></div>
                                        <div class="td">{{info.service_fee}}</div>
                                    </div>
                                    <div class="table__like">
                                        <div class="td">总计</div>
                                        <div class="td-flex"></div>
                                        <div class="td">{{info.total}}</div>
                                    </div>
                                </div>
                            </div>
                            <el-button slot="reference" type="text">项目详情 <i class="el-icon-caret-bottom"></i>
                            </el-button>
                        </el-popover>
                    </div>
                </div>
            </div>
            <div class="pay--content">
                <el-form ref="form" class="pay-form" @submit.native.prevent :model="form" style="width: 360px;margin: 0 auto;" label-width="80px">
                    <el-form-item label="支付方式">
                        余额支付
                    </el-form-item>
                    <el-form-item label="支付金额">
                        {{info.total}}
                    </el-form-item>
                    <el-form-item label="支付密码">
                        <el-input v-model="form.pay_password" placeholder="请输入密码"
                                  type="password"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="paySubmit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'Commit',
    data () {
        return {
            info: {},
            form: {
                pay_password: ''
            }
        }
    },
    mounted () {
        this.getInfo(this.$route.query.id)
    },
    methods: {
        getInfo (id) {
            this.$http.get('/api/user/project/info', {
                params: {
                    id
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.info = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        paySubmit () {
            if (this.form.pay_password === '') {
                this.$message.error('请输入支付密码')
            } else if (!this.info.id) {
                this.$message.error('系统错误，请重新提交订单')
                router.replace('/index/project/add')
            } else {
                // TODO： 支付
                this.$http.post('/api/user/project/pay', qs.stringify({
                    id: this.info.id,
                    pay_password: this.form.pay_password
                }))
                    .then((res) => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: '支付成功。'
                            })
                            router.push(`/index/project/detail?id=${this.info.id}&panel=1`)
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            }
        },
        parseAmount (num) {
            return (num * 1).toLocaleString('zh', { style: 'currency', currency: 'CNY' })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    @import "../../assets/style/sub.scss";

    .table {
        margin: 24px 20px 0;
        border: 1px solid $--border-color-light;
        border-bottom-width: 0;
    }

    .pro-info-box {
        margin-top: 20px;
    }

    .table__like {
        display: flex;
        border-bottom: 1px solid $--border-color-light;

        .td-flex {
            flex: 1;
        }

        .td {
            text-align: center;
            padding: 12px 0;
            line-height: 23px;

            &:first-child {
                width: 200px;
            }

            &:last-child {
                width: 140px;
            }
        }
    }

    .pay__pro {
        .pay--header {
            border-bottom: 1px solid $--border-color-light;
            margin: 0 20px 100px;
            padding-bottom: 2px;

            .title {
                display: flex;
                font-size: 16px;

                .status-bar {
                    flex: 1;
                }

                .price {
                    text-align: right;
                    width: 260px;

                    .value {
                        color: $--color-danger;
                        font-size: 24px;
                    }
                }
            }

            .desc {
                display: flex;
                align-items: center;
                margin-top: 10px;

                .tips {
                    flex: 1;
                }
            }
        }
    }
</style>
